// @flow

/**
 * Do not edit directly
 * Generated on Thu, 20 Feb 2020 17:25:54 GMT
 */

import Color from './Color';

export const BACKGROUND_COLOR_CONTRAST = Color.NEUTRAL_28;
export const BACKGROUND_COLOR_OVERLAY = Color.NEUTRAL_12.withOpacity(0.48);
export const BACKGROUND_COLOR_OVERLAY_ACCENT = Color.GREEN_BASE.withOpacity(0.24);
export const BACKGROUND_COLOR_TERTIARY = Color.NEUTRAL_92;
export const BACKGROUND_COLOR_SECONDARY = Color.NEUTRAL_96;
export const BACKGROUND_COLOR_PRIMARY = Color.NEUTRAL_100;
export const BACKGROUND_COLOR_ERROR = Color.RED_96;
export const BACKGROUND_COLOR_ACCENT = Color.BRAND_ROVER;
export const BORDER_COLOR_PRIMARY = Color.NEUTRAL_84;
export const BORDER_COLOR_SECONDARY = Color.NEUTRAL_88;
export const BORDER_COLOR_ERROR = Color.RED_BASE;
export const BORDER_COLOR_INPUT_FOCUS = Color.BLUE_BASE;
export const INTERACTIVE_TEXT_COLOR_PRIMARY = Color.NEUTRAL_28;
export const INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE = Color.GREEN_24;
export const INTERACTIVE_TEXT_COLOR_DISABLED = Color.NEUTRAL_56;
export const INTERACTIVE_TEXT_COLOR_LINK_PRIMARY = Color.BLUE_32;
export const INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_PRESSED = Color.BLUE_28;
export const INTERACTIVE_TEXT_COLOR_LINK_PRIMARY_INVERSE = Color.NEUTRAL_100;
export const INTERACTIVE_TEXT_COLOR_LINK_SECONDARY = Color.NEUTRAL_44;
export const INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_PRESSED = Color.NEUTRAL_28;
export const INTERACTIVE_TEXT_COLOR_LINK_SECONDARY_INVERSE = Color.NEUTRAL_96;
export const INTERACTIVE_BORDER_COLOR_PRIMARY = Color.NEUTRAL_84;
export const INTERACTIVE_BORDER_COLOR_PRIMARY_PRESSED = Color.NEUTRAL_56;
export const INTERACTIVE_BORDER_COLOR_PRIMARY_ACTIVE = Color.GREEN_BASE;
export const INTERACTIVE_BORDER_COLOR_DISABLED = Color.NEUTRAL_92;
export const INTERACTIVE_BACKGROUND_COLOR_PRIMARY = Color.NEUTRAL_100;
export const INTERACTIVE_BACKGROUND_COLOR_PRIMARY_PRESSED = Color.NEUTRAL_96;
export const INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE = Color.GREEN_96;
export const INTERACTIVE_BACKGROUND_COLOR_PRIMARY_ACTIVE_PRESSED = Color.GREEN_70.withOpacity(0.32);
export const INTERACTIVE_BACKGROUND_COLOR_DISABLED = Color.NEUTRAL_96;
export const SEPARATOR_COLOR_PRIMARY = Color.NEUTRAL_84;
export const TEMPORARY_COLOR_BUTTON_TERTIARY_BACKGROUND_PRESSED = Color.PURPLE_70.withOpacity(0.24);
export const TEMPORARY_COLOR_BUTTON_DESTRUCTIVE_BACKGROUND_PRESSED = Color.RED_70.withOpacity(0.24);
export const TEMPORARY_COLOR_BUTTON_PRIMARY_DISABLED_BACKGROUND = Color.GREEN_BASE.withOpacity(
  0.24
);
export const TEXT_COLOR_PRIMARY = Color.NEUTRAL_12;
export const TEXT_COLOR_PRIMARY_INVERSE = Color.NEUTRAL_100;
export const TEXT_COLOR_SECONDARY = Color.NEUTRAL_28;
export const TEXT_COLOR_SECONDARY_INVERSE = Color.NEUTRAL_96;
export const TEXT_COLOR_TERTIARY = Color.NEUTRAL_44;
export const TEXT_COLOR_TERTIARY_INVERSE = Color.NEUTRAL_92;
export const TEXT_COLOR_DISABLED = Color.NEUTRAL_56;
export const TEXT_COLOR_PLACEHOLDER = Color.NEUTRAL_44;
export const TEXT_COLOR_ERROR = Color.RED_BASE;
export const TEXT_COLOR_PRICE = Color.ORANGE_40;
export const GRADIENT_BASE = 'linear-gradient(45deg, #00CD7A 0%, #14A96D 50%, #00CD7A 100%)';
export const GRADIENT_PRIMARY = 'linear-gradient(180deg, #00BD70 0%, #00CD7A 100%)';
export const GRADIENT_PRIMARY_PRESSED = 'linear-gradient(180deg, #00A362 0%, #00BD71 98.81%)';
export const GRADIENT_DESTRUCTIVE = 'linear-gradient(180deg, #FD3225 0%, #FF645A 100%)';
export const GRADIENT_DESTRUCTIVE_PRESSED = 'linear-gradient(180deg, #BA1C11 0%, #DB291D 98.44%);';
export const BORDER_RADIUS = '4px';
export const SPACE_0X = '0px';
export const SPACE_1X = '4px';
export const SPACE_2X = '8px';
export const SPACE_3X = '12px';
export const SPACE_4X = '16px';
export const SPACE_5X = '20px';
export const SPACE_6X = '24px';
export const SPACE_8X = '32px';
export const SPACE_12X = '48px';
export const SPACE_16X = '64px';
export const SPACE_24X = '96px';
export const HEADING_100_FONT_FAMILY = 'Averta-Semibold';
export const HEADING_100_FONT_SIZE = '13px';
export const HEADING_100_FONT_WEIGHT = 600;
export const HEADING_100_LINE_HEIGHT = 1.25;
export const HEADING_100_MARGIN_BOTTOM = '8px';
export const HEADING_200_FONT_FAMILY = 'Averta-Semibold';
export const HEADING_200_FONT_SIZE = '16px';
export const HEADING_200_FONT_WEIGHT = 600;
export const HEADING_200_LINE_HEIGHT = 1.25;
export const HEADING_200_MARGIN_BOTTOM = '12px';
export const HEADING_300_FONT_FAMILY = 'Averta-Semibold';
export const HEADING_300_FONT_SIZE = '20px';
export const HEADING_300_FONT_WEIGHT = 600;
export const HEADING_300_LINE_HEIGHT = 1.25;
export const HEADING_300_MARGIN_BOTTOM = '16px';
export const HEADING_400_FONT_FAMILY = 'Averta-Extrabold';
export const HEADING_400_FONT_SIZE = '26px';
export const HEADING_400_FONT_WEIGHT = 800;
export const HEADING_400_LINE_HEIGHT = 1.25;
export const HEADING_400_MARGIN_BOTTOM = '20px';
export const HEADING_500_FONT_FAMILY = 'Averta-Extrabold';
export const HEADING_500_FONT_SIZE = '32px';
export const HEADING_500_FONT_WEIGHT = 800;
export const HEADING_500_LINE_HEIGHT = 1.25;
export const HEADING_500_MARGIN_BOTTOM = '24px';
export const HEADING_600_FONT_FAMILY = 'Averta-Extrabold';
export const HEADING_600_FONT_SIZE = '38px';
export const HEADING_600_FONT_WEIGHT = 800;
export const HEADING_600_LINE_HEIGHT = 1.25;
export const HEADING_600_MARGIN_BOTTOM = '32px';
export const HEADING_RESPONSIVE_400_FONT_SIZE = '32px';
export const HEADING_RESPONSIVE_500_FONT_SIZE = '40px';
export const HEADING_RESPONSIVE_600_FONT_SIZE = '48px';
export const PARAGRAPH_100_FONT_SIZE = '13px';
export const PARAGRAPH_100_FONT_WEIGHT = 400;
export const PARAGRAPH_100_LINE_HEIGHT = 1.5;
export const PARAGRAPH_100_MARGIN_BOTTOM = '12px';
export const PARAGRAPH_200_FONT_SIZE = '16px';
export const PARAGRAPH_200_FONT_WEIGHT = 400;
export const PARAGRAPH_200_LINE_HEIGHT = 1.5;
export const PARAGRAPH_200_MARGIN_BOTTOM = '16px';
export const PARAGRAPH_300_FONT_SIZE = '20px';
export const PARAGRAPH_300_FONT_WEIGHT = 400;
export const PARAGRAPH_300_LINE_HEIGHT = 1.5;
export const PARAGRAPH_300_MARGIN_BOTTOM = '24px';
export const TEXT_100_FONT_SIZE = '13px';
export const TEXT_100_FONT_WEIGHT = 400;
export const TEXT_100_LINE_HEIGHT = 1.25;
export const TEXT_200_FONT_SIZE = '16px';
export const TEXT_200_FONT_WEIGHT = 400;
export const TEXT_200_LINE_HEIGHT = 1.25;
export const TEXT_300_FONT_SIZE = '20px';
export const TEXT_300_FONT_WEIGHT = 400;
export const TEXT_300_LINE_HEIGHT = 1.2;



// WEBPACK FOOTER //
// ../design-system/style-dictionary/build/es6/DSToken.js